import { isArray, isObject } from './typeGuards';

export function cloneItem<T = unknown>(item: T): T {
  if (isArray(item)) {
    item = item.map(x => cloneItem(x)) as T;
  } else if (isObject(item)) {
    item = { ...item };
    const object = item as Record<string, unknown>;
    Object.keys(object).forEach(key => {
      object[key] = cloneItem(object[key]);
    });
  }
  return item;
}
